import { AxiosRequestConfig, Method } from 'axios'
import { request } from '../request'

const PROXY_URL = 'api/proxy'
function getProxyRequest<T>(
  url: string,
  method: Method,
  body?: any,
  headers?: any
) {
  return {
    url,
    method,
    data: body,
    headers
  } as AxiosRequestConfig<T>
}

export const proxy = {
  getOld: (url: string) => {
    return request.post(`api/proxyGet`, {
      url: url
    })
  },

  get: (url: string) => {
    return request.post(PROXY_URL, getProxyRequest(url, 'GET'))
  },

  post: (url: string, body: any) => {
    return request.post(PROXY_URL, getProxyRequest(url, 'POST', body))
  },

  put: (url: string, body: any) => {
    return request.post(PROXY_URL, getProxyRequest(url, 'PUT', body))
  },

  delete: (url: string) => {
    return request.post(PROXY_URL, getProxyRequest(url, 'DELETE'))
  }
}
